// extracted by mini-css-extract-plugin
export default {"card":"Card-card_e22an","mostPopularCard":"Card-mostPopularCard_FHhLh","uppercard":"Card-uppercard__fOgj"};